// extracted by mini-css-extract-plugin
module.exports = {"footer":"otherfooter_footer__2FVEE","top":"otherfooter_top__2Sm1N","foot":"otherfooter_foot__3vo4e","copyright":"otherfooter_copyright__y8sAd","links":"otherfooter_links__24iDA"};